module.exports = __webpack_public_path__ + "img/202412_basic_03.e35018e8.jpg";